import React, { Component } from 'react';
import { Link } from 'react-router';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as appActionCreators from '../actions/app';
import * as wsActionCreators from '../actions/workspace';


class Usermenu extends Component {

  constructor(props){
    super(props);
    this.state = {open : false}
    this.handleOpen = this.handleOpen.bind(this)
  }

  handleOpen(){
    this.setState({open: !this.state.open})
  }

  render() {
    const appData = JSON.parse(localStorage.getItem('appData')) || {user:{name:''}};
    if(this.props.wsList.length === 0){
      this.props.getWorkspaceList();
    }
    const mappedWorkspaces = this.props.wsList.map((workspace,index) => {
        let activeStyle = {}
        if(workspace.id === this.props.ws.id){
          activeStyle.color = 'green';
          activeStyle.borderBottom = '2px solid green';
          activeStyle.padding = '5px 10px';
          activeStyle.backgroundColor = '#f0f0f0';
          activeStyle.borderRadius = '5px'
        }
        return(
        <li key={index} style={activeStyle}>
          <span onClick={()=>{this.props.changeWs(workspace);this.handleOpen()}}>
            { workspace.name }
          </span>
        </li>)
    });

    return (
      <div className="user-menu">
        <div className="user-name" onClick={this.handleOpen}>
          <i className="glyphicon glyphicon-user"></i>
          <span >
            { appData.user.name.trunc(15) }
          </span>
        </div>
        { this.state.open ? (
          <div>
            <div className="menu-div">
              <ul>
                <label>محیط‌های کار</label>
                { mappedWorkspaces }
                <hr/>
                <li>
                  <Link to="/app/user" onClick={this.handleOpen}>
                    تنظیمات کاربری
                  </Link>
                </li>
                <li>
                  <Link to="/logout">
                    خروج
                  </Link>
                </li>
              </ul>
            </div>
            <div onClick={this.handleOpen} className="detail-overlayer"></div>
          </div>
        ): null}
        
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    wsList: state.app.work_space_list,
    ws: state.app.work_space
  }
}
const actionCreators = Object.assign({}, appActionCreators, wsActionCreators)

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispachToProps)(Usermenu);
